import Kvp from 'src/components/Shared/UIComponents/Kvp'

type Props = {
  aws_connect_saml_url: string
  organization_connect_arn: string
}

export function AccessOrganization(props: Props) {
  return (
    <>
      <Kvp
        label="access url"
        type="text"
        value={props.aws_connect_saml_url}
        tooltip={
          <p>
            In case this field is empty, your organization is linked to the
            Access URL that was provided during the provisioning of Mobile
            Connect.
          </p>
        }
      />

      <Kvp
        label="instance arn"
        type="text"
        value={props.organization_connect_arn}
        tooltip={
          <p>
            In case this field is missing values like <b>ACCOUNT_ID</b> or{' '}
            <b>INSTANCE_ID</b>, your organization is linked to the correct ARN
            that was provided during the provisioning of Mobile Connect.
          </p>
        }
      />

      {/*
      IF EDITABLE
      <TrackedTextField
        placeholder="https://INSTANCE-NAME.my.connect.aws"
        savedStorage={savedSamlUrl}
        label="Access URL"
        title="aws_connect_saml_url"
        initialValue={props.aws_connect_saml_url}
        tooltip={
          <div className="flex flex-col gap-5">
            <p>
              To find this information, navigate to AWS Console -&gt; Amazon
              Connect -&gt; Select Instance -&gt; Overview.{' '}
            </p>
            <img className="w-full object-fit" src={setup}></img>
            <p>
              In case this field is empty, your organization is linked to the
              Access URL that was provided during the provisioning of Mobile
              Connect.
            </p>
          </div>
        }
      />

      <TrackedTextField
        placeholder="arn:aws:connect:REGION:ACCOUNT_ID:instance/INSTANCE-ID"
        savedStorage={savedConnectArn}
        label="Instance ARN"
        title="organization_connect_arn"
        initialValue={props.organization_connect_arn}
        tooltip={
          <div className="flex flex-col gap-5">
            <p>
              To find this information, navigate to AWS Console -&gt; Amazon
              Connect -&gt; Select Instance -&gt; Overview.{' '}
            </p>
            <img className="w-full object-fit" src={setup}></img>

            <p>
              In case this field is empty, your organization is linked to the
              ARN that was provided during the provisioning of Mobile Connect.
            </p>
          </div>
        }
      />*/}
    </>
  )
}
